import { Button, styled } from "@mui/material";
const ButtonStyle = styled(Button)(({ theme }) => ({
    "&.Mui-disabled": {
        "color": theme.palette.grey[500]
    },
    "textTransform": "none"
}));
const consistentTopHeight = "40px";
const Top = styled("div")(() => ({
    "alignItems": "center",
    "alignSelf": "stretch",
    "display": "flex",
    "justifyContent": "space-between",
    "minHeight": consistentTopHeight
}));
export { ButtonStyle, Top };
